import request from './index'
import { mockRequestDelay } from '../utils/mock'

// 是否使用mock数据，开发环境下默认使用
const USE_MOCK = true;

// 模拟权限数据
const mockPermissionsData = {
  code: "SUCCESS",
  data: {
    // 左侧菜单权限
    menus: [
      {
        id: 1,
        name: '首页',
        path: 'home',
        icon: 'el-icon-menu',
        component: 'views/home/Home.vue',
        children: []
      },
      {
        id: 2,
        name: '用户管理',
        path: 'users',
        icon: 'el-icon-user',
        component: 'views/Users/List.vue',
        children: [
        ]
      },
      {
        id: 14,
        name: '用户提现管理',
        path: 'withdraw-records',
        icon: 'el-icon-wallet',
        component: 'views/finance-cooperation/WithdrawRecords.vue',
        children: []
      },
      {
        id: 6,
        name: '统计管理',
        path: 'statistics',
        icon: 'el-icon-data-analysis',
        component: 'views/statistics/Statistics.vue',
        children: []
      },
      {
        id: 7,
        name: '设备管理',
        path: 'devices',
        icon: 'el-icon-s-tools',
        component: 'views/device-management/Devices.vue',
        children: []
      },
      {
        id: 8,
        name: '清运管理',
        path: 'clearance',
        icon: 'el-icon-truck',
        component: 'views/operation-management/Clearance.vue',
        children: []
      },
      {
        id: 9,
        name: '联营管理',
        path: 'partnership',
        icon: 'el-icon-share-alt',
        component: 'views/finance-cooperation/Partnership.vue',
        children: []
      },
      {
        id: 10,
        name: '投递管理',
        path: 'delivery',
        icon: 'el-icon-send',
        component: 'views/operation-management/Delivery.vue',
        children: []
      },
      {
        id: 11,
        name: '设备重量记录',
        path: 'weight-records',
        icon: 'el-icon-scale',
        component: 'views/data-records/WeightRecords.vue',
        children: []
      },
      {
        id: 12,
        name: '财务管理',
        path: 'finance',
        icon: 'el-icon-money',
        component: 'views/finance-cooperation/Finance.vue',
        children: []
      },
      {
        id: 13,
        name: '开箱记录',
        path: 'opening-records',
        icon: 'el-icon-unlock',
        component: 'views/data-records/BoxRecords.vue',
        children: []
      },
      {
        id: 5,
        name: '系统设置',
        path: 'settings',
        icon: 'el-icon-setting',
        component: 'views/settings/Settings.vue',
        children: []
      }
    ],
    // 按钮权限
    buttons: {
      'user:add': true,
      'user:edit': true,
      'user:delete': false,
      'user:view': true
    }
  },
  message: '获取权限成功'
};

/**
 * 获取用户权限列表
 * @param {Object} params - 请求参数
 * @param {Boolean} params.getAll - 是否获取全部权限（用于处理分页）
 */
export function getPermissions(params = {}) {
  if (USE_MOCK) {
    // 使用mock数据
    return new Promise((resolve) => {
      // 模拟网络延迟
      mockRequestDelay().then(() => {
        const hiddenPaths = ['statistics', 'partnership', 'finance', 'opening-records', 'settings']
        const filteredMenus = (mockPermissionsData.data.menus || []).filter(m => !hiddenPaths.includes(m.path))
        const filtered = { ...mockPermissionsData, data: { ...mockPermissionsData.data, menus: filteredMenus } }
        resolve(filtered);
      });
    });
  } else {
    // 实际请求后端API
    // 如果需要获取全部权限，设置相应参数
    const requestParams = { ...params };
    
    // 获取全部权限的逻辑
    if (params.getAll) {
      // 为了获取全部权限，我们需要循环请求所有分页数据
      return new Promise((resolve, reject) => {
        const allPermissions = {
          menus: [],
          buttons: {}
        };
        let currentPage = 1;
        const page_size = 100; // 每页大小
        let hasMoreData = true;
        
        const fetchAllPages = async () => {
          while (hasMoreData) {
            try {
              const response = await request({
                url: '/v1/permissions',
                method: 'get',
                params: {
                  page: currentPage,
                  page_size: page_size,
                  ...requestParams
                }
              });
              
              if (response.code === 'SUCCESS' && response.data) {
                const { menus = [], buttons = {} } = response.data;
                
                // 合并菜单数据
                if (menus && menus.length > 0) {
                  allPermissions.menus = [...allPermissions.menus, ...menus];
                  // 检查是否还有更多数据
                  hasMoreData = menus.length === page_size;
                  currentPage++;
                } else {
                  hasMoreData = false;
                }
                
                // 合并按钮权限（以最后一页的为准，或根据实际业务逻辑处理）
                if (Object.keys(buttons).length > 0) {
                  allPermissions.buttons = { ...allPermissions.buttons, ...buttons };
                }
              } else {
                hasMoreData = false;
              }
            } catch (error) {
              reject(error);
              return;
            }
          }
          
          // 所有页数据获取完成
          resolve({
            code: 'SUCCESS',
            data: allPermissions,
            message: '获取全部权限成功'
          });
        };
        
        fetchAllPages();
      });
    } else {
      // 普通请求，使用默认分页
      return request({
        url: '/v1/permissions',
        method: 'get',
        params: requestParams
      });
    }
  }
}
